<style scoped>
.root {
  position: fixed !important;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 74%);
  transition: opacity 0.4s ease;
  display: flex;
  justify-content: center;
}
.container1 {
  width: 84%;
  max-width: 600px;
  margin: auto;
  background: white;
}

.root {
  height: 100%;
  position: relative;
}
.inner-margin {
  margin: 1.5rem;
}
.fr {
  float: right;
}
.close {
  cursor: pointer;
}
.errorMsg {
  color: red;
  font-size: 12px;
}
p {
  color: black;
}
</style>

<template lang="pug">
.root
  .container1
    .inner-margin
      .text-right
        a(@click='$emit("close")')
          i.material-icons.close close
      v-row(v-if='!issubscribe', align='center', ref='form')
        v-col(cols='12', sm='12')
          h4 Subscribe to our newsletter
          p Subscribe to our newsletter to get updates and amazing offers delivered directly in your inbox.

        v-col(cols='12', sm='6')
          v-text-field(
            v-model='userData.name.firstname',
            placeholder='ex. John',
            label='FirstName'
          )
        v-col(cols='12', sm='6')
          v-text-field(
            v-model='userData.name.lastname',
            placeholder='ex. Doe',
            label='Lastname'
          )
        v-col(cols='12', sm='12')
          v-text-field#email(
            v-model='userData.email',
            placeholder='ex. john.doe@gmail.com',
            type='email',
            name='email',
            label='Email *',
            :rules='emailRules',
            required
          )
          //- .errorMsg(v-if='errorsss.erremail') {{ errorsss.erremail }}
        .vspace.large.col.s12
        .col.s12
          button.btn.fr(@click='subscribe()') Submit
      .row(v-if='issubscribe')
        .col.s12(style='text-align: center')
          img(:src='"./../assets/img/logo_thumb.png"', width='70')
          h4 Thank you !
          p Thanks for subscribing to our newsletter.
</template>
<script>
import axios from 'axios'

export default {
  name: 'appnewsletter',
  data() {
    return {
      userData: {
        name: { firstname: null, lastname: null },
        email: null,
        id: this.userId,
      },
      errorsss: {
        fname: null,
        lname: null,
        erremail: null,
      },
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  computed: {
    issubscribe() {
      return this.$store.state.customer.isSubscribeNewsletter
    },
    userId() {
      if (this.$store.state.user) {
        return this.$store.state.user.id
      } else {
        return 'null'
      }
    },
  },
  methods: {
    subscribe() {
      if (this.$store.state.user) {
        this.userData.id = this.$store.state.user.id
      } else {
        this.userData.id = null
      }
      // this.userData.id = !this.$store.state.user
      //   ? this.$store.state.user.id
      //   : 0

      if (!this.validEmail(this.userData.email)) {
        this.errorsss.erremail = 'Valid Email required'
      } else {
        this.errorsss.erremail = null
        axios
          .post(
            `${this.$config.API_URL}/newsletter/sib-subscribe`,
            this.userData
          )
          .then((res) => {
            if (res.data === 'error') {
              this.errorsss.erremail = 'Email already exist'
            } else {
              this.errorsss.erremail = null
              if (this.$store.state.user === null) {
                this.$store.dispatch('customer/isGuestSubs')
              } else {
                this.$store.dispatch('customer/isSubscribeNewsletter')
              }
            }
          })
      }
    },
    validEmail(email) {
      var re =
        /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-newsletter-form.vue